import { Key } from "react"
import { Block, HeadingXXLarge, useStyletron } from "@mezo-org/mezo-clay"

import { DepositPageTab } from "#/shared/types"

import DepositCompletedScore from "./DepositCompletedScore"

type DepositCompletedProps = {
  setActiveTab: (key: Key) => void
}

export default function DepositCompleted({
  setActiveTab,
}: DepositCompletedProps) {
  const [, theme] = useStyletron()

  return (
    <>
      <HeadingXXLarge marginBottom={theme.sizing.scale1000}>
        <Block as="span" color={theme.colors.red500}>
          Nice One!
        </Block>{" "}
        <br />
        Deposit is on it&apos;s way.
      </HeadingXXLarge>
      <DepositCompletedScore
        onClick={() => setActiveTab(DepositPageTab.MANAGE)}
      />
    </>
  )
}
